import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { AssignedProject } from "@/types";

type Params = {
  role: string;
};

export function useAssignedProjects(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["assigned-projects", params],
    queryFn: () => apiFetch<AssignedProject[]>(`/v1/home/assigned-projects${query}`),
    enabled: true, // TODO: remove when API is ready
  });
}
